import { Box, MenuItem, TextField, Typography } from "@mui/material";
import { Snapshot } from "../../../types/snapshot";

interface SnapshotSelectProps {
  label: string;
  snapshots: Snapshot[];
  value: string | null;
  onChange: (snapshot: Snapshot | null) => void;
}

/** Snapshot picker with thumbnail previews, shared by image/compare blocks. */
export default function SnapshotSelect({
  label,
  snapshots,
  value,
  onChange,
}: SnapshotSelectProps) {
  return (
    <TextField
      select
      label={label}
      size="small"
      fullWidth
      value={value ?? ""}
      onChange={(e) => {
        const snapshot = snapshots.find((s) => s.id === e.target.value) ?? null;
        onChange(snapshot);
      }}
    >
      <MenuItem value="">None</MenuItem>
      {snapshots.map((snapshot) => (
        <MenuItem key={snapshot.id} value={snapshot.id}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
            <Box
              component="img"
              src={snapshot.imageUrl}
              alt=""
              sx={{ width: 48, height: 30, objectFit: "cover", borderRadius: 0.5 }}
            />
            <Typography variant="body2" noWrap>
              {snapshot.description || "Untitled snapshot"}
            </Typography>
          </Box>
        </MenuItem>
      ))}
    </TextField>
  );
}
